const calendarModal = {
  width: 'w-full sm:max-w-xl',
}

export { calendarModal }
